import { render, staticRenderFns } from "./EditarComarca.vue?vue&type=template&id=712d6985&scoped=true"
import script from "./EditarComarca.vue?vue&type=script&lang=js"
export * from "./EditarComarca.vue?vue&type=script&lang=js"
import style0 from "./EditarComarca.vue?vue&type=style&index=0&id=712d6985&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d6985",
  null
  
)

export default component.exports